import { useCallback, useEffect, useState } from 'react';
import { DataState } from '@betty/toolkit/state';
import { logError } from '@betty/toolkit/logging';
import { sortWinners } from './useMilestoneWinners.utils';
import {
  MilestoneWinner,
  CommunityEventMilestone,
} from '../../state/communityJackpot.types';
import CommunityEventService from '../../services/CommunityEventService/CommunityEventService';

const useMilestoneWinners = (id: CommunityEventMilestone['id']) => {
  const [data, setData] = useState<MilestoneWinner[]>([]);
  const [dataState, setDataState] = useState<DataState>('idle');

  const fetch = useCallback(async () => {
    try {
      setDataState('pending');

      const { milestoneWinners } =
        await CommunityEventService.getMilestoneWinners({
          pathParams: { milestoneId: id },
        });

      setData(sortWinners(milestoneWinners));
      setDataState('fulfilled');
    } catch (error) {
      logError('Failed to fetch milestone winners', error);
      setDataState('rejected');
    }
  }, [id]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    data,
    dataState,
  };
};

export default useMilestoneWinners;
